import React, { createContext, useState, useContext } from 'react';

const AdminPurchasesContext = createContext();

export const AdminPurchasesProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    selectedDate: '',
    purchases: [],
    lastVisible: null,
    allLoaded: false,
  });

  return (
    <AdminPurchasesContext.Provider value={{ filters, setFilters }}>
      {children}
    </AdminPurchasesContext.Provider>
  );
};

export const useAdminPurchases = () => useContext(AdminPurchasesContext);
